/* =========================================================================
   SAV CARD — motion layer
   Adds parallax hero, staggered scroll reveals, and a cinematic hero
   entrance to the #savc-root section. Self-contained: injects its own CSS
   and wraps the hero image itself, so sections/sav-card.liquid needs no
   markup changes beyond loading this file.

   Matches the motion language of the Collection Flip Toggle section.
   Honours prefers-reduced-motion — everything is disabled and content
   simply appears.
   ========================================================================= */
(function () {
  function init() {
    var R = document.getElementById('savc-root');
    if (!R || R.dataset.savcMotion === 'on') return;
    R.dataset.savcMotion = 'on';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- injected styles ---------- */
    var css = document.createElement('style');
    css.textContent = [
      '#savc-root .savc-hero{position:relative;overflow:hidden}',
      '#savc-root .savc-herofull{will-change:transform;transform-origin:center center}',

      '#savc-root .savc-hero-in{opacity:0;transform:translateY(20px);',
      'animation:savcHeroIn 900ms cubic-bezier(.16,.84,.44,1) forwards}',
      '#savc-root .savc-hero-in.d1{animation-delay:120ms}',
      '#savc-root .savc-hero-in.d2{animation-delay:260ms}',
      '#savc-root .savc-hero-in.d3{animation-delay:400ms}',
      '@keyframes savcHeroIn{to{opacity:1;transform:translateY(0)}}',

      '#savc-root .savc-m-reveal{opacity:0;transform:translateY(26px);',
      'transition:opacity .8s cubic-bezier(.16,.84,.44,1),transform .8s cubic-bezier(.16,.84,.44,1)}',
      '#savc-root .savc-m-reveal.in{opacity:1;transform:none}',

      '#savc-root .savc-reveal{transition:opacity .85s cubic-bezier(.16,.84,.44,1),transform .85s cubic-bezier(.16,.84,.44,1)}',

      '@media(prefers-reduced-motion:reduce){',
      '#savc-root .savc-hero-in,#savc-root .savc-m-reveal{animation:none!important;transition:none!important;opacity:1!important;transform:none!important}',
      '#savc-root .savc-herofull{transform:none!important}}'
    ].join('');
    document.head.appendChild(css);

    /* ---------- 1. parallax hero ---------- */
    var heroImg = R.querySelector('.savc-herofull');
    var hero = R.querySelector('.savc-hero');
    if (heroImg && hero && !reduce) {
      var tickHero = function () {
        if (heroImg.style.display !== 'none' && hero.offsetParent !== null) {
          var rect = hero.getBoundingClientRect();
          var mid = rect.top + rect.height / 2 - window.innerHeight / 2;
          heroImg.style.transform = 'translateY(' + (mid * -0.14) + 'px) scale(1.08)';
        }
        requestAnimationFrame(tickHero);
      };
      requestAnimationFrame(tickHero);
    }

    /* ---------- 2. hero entrance ---------- */
    var heroCta = R.querySelector('.savc-hero-cta');
    if (heroCta) heroCta.classList.add('savc-hero-in', 'd3');
    var fbRight = R.querySelector('.savc-fb-right');
    if (fbRight) fbRight.classList.add('savc-hero-in', 'd1');
    var fbLeft = R.querySelector('.savc-fb-left');
    if (fbLeft) fbLeft.classList.add('savc-hero-in', 'd2');

    /* ---------- 3. stagger the existing section reveals ---------- */
    ['.savc-threecol', '.savc-tiers', '.savc-steps'].forEach(function (sel) {
      R.querySelectorAll(sel).forEach(function (group) {
        group.querySelectorAll('.savc-reveal').forEach(function (el, i) {
          el.style.transitionDelay = (i * 110) + 'ms';
        });
      });
    });

    /* ---------- 4. reveal the dynamically-rendered content ---------- */
    var mio = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in'); mio.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
      : null;

    function stagger(container, itemSel, step) {
      var host = R.querySelector(container);
      if (!host) return;
      host.querySelectorAll(itemSel).forEach(function (el, i) {
        if (el.classList.contains('savc-m-reveal')) return;
        el.classList.add('savc-m-reveal');
        el.style.transitionDelay = (i * step) + 'ms';
        if (mio && !reduce) { mio.observe(el); } else { el.classList.add('in'); }
      });
    }

    function applyAll() {
      stagger('#savc-cardGrid', '.savc-cell', 80);
      stagger('#savc-ledger', '.savc-lrow', 70);
      stagger('#savc-updates', '.savc-update', 90);
      stagger('#savc-tracker', '.savc-slot', 60);
    }

    applyAll();

    var grid = document.getElementById('savc-cardGrid');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { applyAll(); })
        .observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
